{
  "tabs": {
    "chat": "Chat",
    "reminders": "Kumbusho",
    "calendar": "Kalenda",
    "settings": "Mipangilio"
  },
  "common": {
    "cancel": "Ghairi",
    "save": "Hifadhi",
    "confirm": "Thibitisha",
    "delete": "Futa",
    "back": "Rudi",
    "close": "Funga",
    "edit": "Hariri",
    "search": "Tafuta",
    "all": "Zote",
    "loading": "Inapakia...",
    "error": "Kitu kimekwenda vibaya",
    "notFound": "Hakikupatikana",
    "tryAgain": "Jaribu tena tafadhali",
    "retry": "Jaribu tena",
    "undo": "Rudisha",
    "pullToRefresh": "Vuta kusasisha",
    "justNow": "sasa hivi"
  },
  "auth": {
    "welcome": "Karibu FishMemory",
    "tagline": "Msaidizi wako wa kumbusho wa WhatsApp, sasa mfukoni mwako.",
    "subtitle": "Msaidizi wako wa kumbusho wa WhatsApp, sasa mfukoni mwako.",
    "phoneLabel": "Nambari yako ya WhatsApp",
    "phoneHint": "Tutakutumia msimbo wa uthibitisho kupitia WhatsApp",
    "invalidPhone": "Tafadhali ingiza nambari halali ya simu",
    "continue": "Endelea",
    "enterPhone": "Ingiza nambari yako ya WhatsApp",
    "phonePlaceholder": "Nambari ya simu",
    "sendCode": "Tuma Msimbo",
    "verifyTitle": "Thibitisha nambari yako",
    "otpSentTo": "Msimbo wa tarakimu 6 umetumwa kwa {{phone}} kupitia WhatsApp",
    "enterFullCode": "Tafadhali ingiza tarakimu zote 6",
    "invalidOtp": "Msimbo si sahihi. Tafadhali jaribu tena.",
    "otpFailed": "Imeshindikana kutuma msimbo. Jaribu tena.",
    "otpResent": "Msimbo umetumwa tena",
    "resendIn": "Tuma tena baada ya {{seconds}}s",
    "resendCode": "Tuma msimbo tena",
    "enterOtp": "Ingiza msimbo uliopelekwa kwa WhatsApp yako",
    "verify": "Thibitisha",
    "resend": "Tuma tena",
    "wrongNumber": "Nambari si sahihi?",
    "backToPhone": "Rudi kwa simu",
    "editPhone": "Hariri nambari ya simu",
    "error": "Hitilafu",
    "setupTitle": "Tuweke mambo sawa",
    "setupSubtitle": "Unaweza kubadilisha haya baadaye katika Mipangilio",
    "namePlaceholder": "Jina lako",
    "letsGo": "Maliza usanidi",
    "skipForNow": "Ruka kwa sasa"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Andika ujumbe...",
    "inputPlaceholder": "Andika ujumbe...",
    "typing": "FishMemory inaandika...",
    "online": "Mtandaoni",
    "connecting": "Inajiunga...",
    "reconnecting": "Inajiunga tena...",
    "offline": "Hajatangazwa mtandaoni",
    "empty": "Anza mazungumzo",
    "emptyHint": "Tengeneza kumbusho, angalia ratiba, au omba msaada.",
    "emptyAction": "Tuma kumbusho la mfano",
    "actions": "Vitendo vya chat",
    "keep": "Hifadhi ujumbe",
    "clearTitle": "Futa mazungumzo",
    "clearConfirm": "Futa ujumbe wote kutoka kifaa hiki? Haitaweza kurekebishwa.",
    "clear": "Futa mazungumzo",
    "optionSelected": "Imechaguliwa: {{label}}",
    "sendingSelection": "Inatuma...",
    "connectionLost": "Inajiunga tena..."
  },
  "reminders": {
    "title": "Kumbusho Zangu",
    "active": "Zenye nguvu",
    "today": "Leo",
    "thisWeek": "Wiki Hii",
    "history": "Historia",
    "items": "vitu",
    "emptyTitle": "Hakuna kumbusho bado",
    "emptySubtitle": "Tengeneza moja kutoka chat na itaonekana hapa.",
    "emptyAction": "Fungua chat",
    "filterActive": "Zenye nguvu",
    "filterToday": "Leo",
    "filterWeek": "Wiki Hii",
    "filterHistory": "Historia",
    "emptyState": "Hakuna kumbusho bado. Anza kuzungumza!",
    "swipeDone": "Imekamilika",
    "swipeSnooze": "Lala kidogo",
    "swipeDelete": "Futa",
    "search": "Tafuta kumbusho...",
    "upcoming": "Zijazo",
    "completed": "Zilikamilika",
    "overdue": "Zilizochelewa",
    "tomorrow": "Kesho",
    "synced": "Imeambatanishwa {{value}}",
    "swipeHint": "Swipe kumbusho kwa vitendo zaidi",
    "noResults": "Hakuna kumbusho linalolingana na utafutaji wako",
    "noResultsHint": "Jaribu neno tofauti au futa utafutaji",
    "deleteAllFailed": "Imeshindikana kufuta kumbusho zote"
  },
  "calendar": {
    "title": "Kalenda",
    "today": "Leo",
    "tomorrow": "Kesho",
    "completed": "imekamilika",
    "noEvents": "Hakuna ratiba",
    "noEventsSubtitle": "Chagua tarehe kuona kumbusho na matukio ya kalenda.",
    "googleEvent": "Kalenda ya Google",
    "legendActive": "Zenye nguvu",
    "legendRecurring": "Zinarudiwa",
    "legendDone": "Zimekamilika",
    "legendGoogle": "Google",
    "previousMonth": "Mwezi uliopita",
    "nextMonth": "Mwezi ujao",
    "previousYear": "Mwaka uliopita",
    "nextYear": "Mwaka ujao",
    "goToToday": "Nenda leo",
    "all": "Zote",
    "active": "Zenye nguvu",
    "done": "Zimekamilika",
    "paused": "Imezimwa"
  },
  "settings": {
    "title": "Mipangilio",
    "profile": "Wasifu",
    "name": "Jina la kuonyesha",
    "enterName": "Ingiza jina lako",
    "language": "Lugha",
    "uiLanguage": "Lugha ya app",
    "uiLanguageHelp": "Hubadilisha UI ya app, lebo za kalenda, na mwelekeo wa mpangilio kwenye kifaa hiki pekee.",
    "serverLanguage": "Lugha ya chat",
    "serverLanguageHelp": "Hubadilisha lugha inayotumika na majibu ya seva na ujumbe wa kumbusho kwa akaunti yako.",
    "timezone": "Mkoa wa saa",
    "currentTimezone": "Mkoa wa saa wa sasa",
    "timezoneHelp": "Muda wote wa kumbusho unaonyeshwa kwa kutumia mkoa huu wa saa.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Hifadhi mkoa wa saa",
    "timezoneSaved": "Mkoa wa saa umebadilishwa",
    "detect": "Tambua",
    "detectFailed": "Haikuweza kubaini mkoa wa saa",
    "autoDetect": "Tambua moja kwa moja kwa GPS",
    "notifications": "Arifa",
    "notificationsHelp": "Kumbusho za kufuatilia hudhibiti arifa zinazorudi baada ya kumbusho kutumwa. Ruhusa za arifa za kifaa bado zinadhibitiwa katika mipangilio ya simu yako.",
    "pushEnabled": "Arifa za Push",
    "autoDoneOnFire": "Weka moja kwa moja kama limekamilika linapowaka",
    "autoDoneOnFireDesc": "Ikiwa imezimwa, kumbusho hubaki hai hadi utakapoweka kama limekamilika.",
    "googleCalendar": "Kalenda ya Google",
    "google": "Kalenda ya Google",
    "googleConnected": "Imeunganishwa",
    "googleDisconnected": "Haijaunganishwa",
    "googleConnectedHelp": "Kumbusho mpya zinaweza kuambatanishwa moja kwa moja kwenye kalenda yako.",
    "googleDisconnectedHelp": "Unganisha Kalenda ya Google ili kuweka kumbusho na matukio sawa.",
    "googleConnectFailed": "Imeshindikana kuunganisha Kalenda ya Google",
    "connected": "Imeunganishwa",
    "disconnected": "Haijaunganishwa",
    "connect": "Unganisha",
    "disconnect": "Tenganisha",
    "autoSync": "Ambatanisha kumbusho mpya moja kwa moja",
    "autosync": "Ambatanisha kumbusho mpya moja kwa moja",
    "subscription": "Usajili",
    "trialUsed": "Jaribio: {{used}}/{{total}} tumetumia",
    "trialStatus": "Jaribio linapatikana",
    "activeStatus": "Usajili hai",
    "expiredStatus": "Usajili umeisha",
    "unsubscribedStatus": "Hujisajili",
    "about": "Kuhusu",
    "version": "Toleo",
    "logout": "Toka",
    "logoutTitle": "Toka",
    "logoutConfirm": "Una uhakika unataka kutoka?",
    "noName": "Hakuna jina limewekwa",
    "serverConnection": "Muunganisho wa seva",
    "serverUrl": "URL ya seva",
    "serverEdit": "Hariri",
    "saveReconnect": "Hifadhi na uungane tena",
    "resetDefault": "Rejesha chaguo la awali",
    "invalidServerUrlTitle": "URL ya seva si halali",
    "invalidServerUrlMessage": "Ingiza URL halali ya seva ya http au https, kwa mfano https://example.com",
    "uiLanguageChangeFailed": "Imeshindikana kubadilisha lugha ya app. Tafadhali jaribu tena.",
    "serverLanguageChangeFailed": "Imeshindikana kubadilisha lugha ya chat. Tafadhali jaribu tena.",
    "timezoneChangeFailed": "Imeshindikana kubadilisha mkoa wa saa. Tafadhali jaribu tena.",
    "autoSyncChangeFailed": "Imeshindikana kusasisha ambatanisho moja kwa moja. Tafadhali jaribu tena.",
    "nameChangeFailed": "Imeshindikana kusasisha jina la kuonyesha. Tafadhali jaribu tena.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Maelezo ya kumbusho",
    "editTime": "Hariri Muda",
    "rename": "Badilisha Jina",
    "snooze": "Lala kidogo",
    "snooze15": "Lala kidogo dakika 15",
    "pause": "Sitisha",
    "pauseReminder": "Sitisha kumbusho",
    "resume": "Endelea",
    "resumeReminder": "Endelea kumbusho",
    "skip": "Ruka Ifuatayo",
    "skipOccurrence": "Ruka tukio hili",
    "syncGoogle": "Ambatanisha na Google",
    "delete": "Futa",
    "deleteTitle": "Futa Kumbusho",
    "deleteConfirm": "Kumbusho hili litaondolewa kabisa.",
    "deleteRecurringTitle": "Futa Kumbusho Zinazorudiwa",
    "deleteRecurringMessage": "Unataka kuruka tukio hili au kufuta mfululizo mzima?",
    "deleteThisOccurrence": "Ruka Tukio Hili",
    "deleteEntireSeries": "Futa Mfululizo Wote",
    "done": "Imekamilika",
    "markDone": "Weka kama imekamilika",
    "undo": "Rejesha",
    "undoPrompt": "Unahitaji iwe hai tena? Rejesha sasa.",
    "recurring": "Inarudiwa",
    "nextRun": "Inayofuata",
    "oneTime": "Mara moja",
    "pending": "Inasubiri",
    "sent": "Imetumwa",
    "paused": "Imesitishwa",
    "active": "Hai",
    "snoozed": "Imelala kidogo",
    "localTime": "Inaonyeshwa kwa saa yako ya eneo",
    "recurrence": "Kurudia",
    "created": "Imeundwa",
    "tags": "Lezo",
    "fireCount": "Mara zilizotokea",
    "actions": "Vitendo",
    "none": "Hakuna",
    "snoozeFailed": "Imeshindikana kulala kidogo kumbusho",
    "pauseFailed": "Imeshindikana kusitisha kumbusho",
    "resumeFailed": "Imeshindikana kuendelea na kumbusho",
    "skipFailed": "Imeshindikana kuruka kumbusho",
    "doneFailed": "Imeshindikana kuweka kumbusho kama limekamilika",
    "undoFailed": "Imeshindikana kurejesha hali ya kumbusho",
    "deleteFailed": "Imeshindikana kufuta kumbusho",
    "rescheduleTitle": "Panga upya?",
    "rescheduleMsg": "Kumbusho hili limechelewa. Ungependa kulipanga upya?",
    "reschedule15": "Baada ya dakika 15",
    "reschedule60": "Baada ya saa 1",
    "keepOverdue": "Baki kama ilivyo"
  },
  "onboarding": {
    "slide1Title": "Karibu FishMemory",
    "slide1Sub": "Msaidizi wako wa kumbusho binafsi — unaotumia WhatsApp na umejengwa kwa mfukoni mwako.",
    "slide2Title": "Zungumza Tu Kiasili",
    "slide2Sub": "Andika kumbusho kama unavyofikiria: \"Nikumbushe kumpigia mama simu kesho saa 9\" — sisi tunashughulikia mengine.",
    "slide3Title": "Usikose Kitu",
    "slide3Sub": "Pata arifa kwa wakati, panga kwa lezo, na fuatilia kila kitu muhimu.",
    "getStarted": "Anza",
    "next": "Ifuatayo",
    "firstReminderTitle": "Tengeneza kumbusho lako la kwanza!",
    "firstReminderHint": "Jaribu kuandika kitu kama:",
    "firstReminderExample": "Nikumbushe kunywa maji kesho saa 3 asubuhi",
    "gotIt": "Nimeelewa!",
    "notifRationaleTitle": "Kaa Muda",
    "notifRationaleBody": "FishMemory inahitaji arifa kukukumbusha kwa wakati. Utapokea arifa tu kwa kumbusho ulizotengeneza.",
    "notifRationaleAllow": "Washa Arifa",
    "notifRationaleLater": "Labda Baadaye",
    "swipeHint": "Swipe kulia kwa vitendo vya haraka →",
    "calendarDragHint": "Vuta kupanua ↕"
  }
}
